export default __webpack_public_path__ + "static/media/Batimetrías.ed909551.png";